import { Injectable } from '@angular/core';
import { ToastsManager } from 'ng2-toastr';

@Injectable()
export class AlertService {

  constructor(public toastr: ToastsManager) {
  }

  success(message: string, title: string = '') {
    this.toastr.success(message, title);
  }

  error(message: string, title: string = '') {
    this.toastr.error(message, title);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/alert.service.ts